import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_CONNECTIONS = 'GET_CONNECTIONS';
export const GET_ACCOUNTS = 'GET_ACCOUNTS';

export const actions = createSagaActionTypes('CONNNECTIONS', [
  GET_CONNECTIONS,
  GET_ACCOUNTS
]);
